<template>
	<div class="bike_list_descr mr-0" v-if="infobike">
		<div class="bike_list_cont">
			<div class="bike-title">{{ infobike.nome }}</div>
			<div class="bike-descr">
				<div class="bike_container">
					<div v-if="infobike.img" class="img_bike">
						<img :src="infobike.img" :alt="infobike.nome" />
					</div>
					<div v-else class="img_bike_classic">
						<img :src="defaultBikeImage" alt="auto icon" width="140px" />
					</div>
					<div class="row_descr row_descr_2">
						<div class="border-right">
							<div v-for="(item, index) in leftColumn" :key="index" class="single_row">
								<span class="label-bold">{{ item.label }}:</span>
								<span>{{ item.value }}</span>
							</div>
						</div>
						<div>
							<div v-for="(item, index) in rightColumn" :key="index" class="single_row">
								<span class="label-bold">{{ item.label }}:</span>
								<span>{{ item.value }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BikeRecap',
	props: {
		infobike: {
			type: Object,
			required: true,
		},
		quotationType: {
			type: String,
			required: true,
		},
	},
	computed: {
		leftColumn() {
			return [
				{ label: 'Cilindrata', value: this.infobike.cilindrata },
				{ label: 'Potenza Kw/CV', value: this.infobike.potenza },
				{ label: 'Normativa Euro', value: this.infobike.normativaEuro },
			];
		},
		rightColumn() {
			return [
				{ label: 'Cambio', value: this.infobike.cambio },
				{ label: 'Freno Anteriore', value: this.infobike.frenoAnteriore },
				{ label: 'Freno Posteriore', value: this.infobike.frenoPosteriore },
			];
		},
		defaultBikeImage() {
			return '../../../images/project-img/ico-classic-grey.png';
		},
	},
};
</script>
<style scoped>
.img_bike_classic {
	margin-left: 18px;
	width: 375px;
	height: 175px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 6px;
	background-color: #d9d9d9;

	img {
		max-width: 275px;
	}

	@media (max-width: 768px) {
		margin: 0 auto;
	}
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/BikeRecap.vue